import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../util/auth.guard';
import { EmailPersonalizadoComponent } from './email-personalizado/email-personalizado.component';

const routes: Routes = [
  { path: '', component: EmailPersonalizadoComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmailPersonalizadoRoutingModule { }
